<li>
  <a href='#' [ngClass]='{ expand: true, expanded: expanded }' [attr.aria-expanded]='expanded' (click)='toggle($event)'>
    <span class='sr-only'>Rozwiń</span>
    <h3><span [innerHTML]="name"></span> <ng-content select="[slot=action]"></ng-content></h3>
  </a>
  <div [ngClass]='{ info: true, expanded: expanded }'>
    <ng-container *ngIf='expanded'>
      <ng-content></ng-content>
    </ng-container>
  </div>
</li>
